<template>
  <div>
    <el-upload
      ref="upload"
      :action="qiniuUploadUrl"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :auto-upload="autoUpload"
      :on-change="handleChange"
      :multiple="limit > 1"
      :on-exceed="handleExceed"
      :on-remove="handleRemove"
      list-type="picture"
      :accept="accept"
      :data="postQiNiuData"
      :on-error="handleError"
      :limit="limit"
      :file-list="localFileLists"
    >
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件,最多能上传<span>{{ limit }}</span>张</div>

    </el-upload>
  </div>
</template>

<script>

import axios from 'axios';
import { createQiniuKey, createQiniuUrl } from './qiniuhelper';
// import { setImgExpirationTime } from '@/api/common'

export default {
  name: 'QiniuUpload',
  props: {
    autoUpload: {
      type: Boolean,
      default: true
    },
    files: {
      type: [Array, String],
      default() {
        return []
      }
    },
    limit: {
      type: Number,
      default: 1
    },
    accept: {
      type: String,
      default: '.jpg,.jpeg,.png,.JPG,.JPEG'
    },
    expire: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ''
    },
    upType: {
      type: String,
      default: 'upload'
    }

  },
  data() {
    return {
      qiniuUploadUrl: 'https://up-z2.qiniup.com',
      postQiNiuData: {
        token: ''
      },
      userInfo: localStorage.userInfo
        ? JSON.parse(localStorage.userInfo)
        : {},
      localFileLists: [],
      uploadUrl: [],
      totalUploads: 0
    }
  },
  watch: {
    files: {
      handler(newVal) {
        if (!newVal) {
          this.localFileLists = []
        } else if (typeof newVal === 'string') {
          this.localFileLists = newVal.split(',').map(item => {
            return { url: item }
          })
        } else if (Array.isArray(newVal)) {
          this.localFileLists = newVal.map(item => {
            return { url: item }
          })
        } else {
          return
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getUploadToken()
  },
  mounted() {

  },
  methods: {
    submit() {
      if (this.autoUpload) {
        return
      }
      this.$refs['upload'].submit()
    },
    getUploadToken() {
      axios.get('https://third.tuolele.cn/qtoken.php').then(res => {
        this.postQiNiuData.token = res.data.token
      })
    },
    handleChange(file, fileList) {
      this.totalUploads = fileList.length // 更新总上传数
    },
    handleRemove(file, fileList) {
      this.uploadUrl = this.uploadUrl.filter((item) => {
        return item.indexOf(file.response.key) === -1
      })
      this.$emit('success', { urls: this.uploadUrl, name: this.name, type: 'delete' })
    },
    beforeUpload(e) {
      const nameSplit = e.name.split('.')
      const type = nameSplit[nameSplit.length - 1]
      this.postQiNiuData.key = createQiniuKey(`${this.userInfo.company_id}_tuolelecms_${this.upType}`, type)
    },
    async handleSuccess(e, file, fileLists) {
      const { key } = e
      const newUrl = createQiniuUrl(key)
      this.uploadUrl.push(newUrl)
      // 保存图片过期时间
      //   if (this.expire) {
      //     await setImgExpirationTime({ url: newUrl, day: this.expire })
      //   }
      const successLists = fileLists.filter(item => item.status === 'success')
      if (successLists.length !== fileLists.length) {
        return
      }
      // 如自动上传 则直接通知，如非自动上传 则等待全部上传完毕通知
      if (this.autoUpload) {
        this.$emit('success', { urls: this.uploadUrl, name: this.name, type: 'upload' })
        return
      }
      if (this.uploadUrl.length === this.totalUploads) {
        this.$emit('success', { urls: this.uploadUrl, name: this.name, type: 'upload' })
      }
    },
    handleError(e) {
      console.log(e)
      this.$emit('error', e)
    },
    handleExceed() {
      this.$message.error('最多只能上传' + this.limit + '张图片')
      this.$emit('error', 'exceed')
    }
  }
}
</script>

  <style></style>
